import type { FC } from 'react';
import React from 'react';
import styled, { css } from 'styled-components';
import { useTranslation } from '@lt/localization';
import { Bus } from '@lt/components/icons-react/userflow';
import { Clock } from '@lt/components/icons-react';
import PackageInfoItem from '../components/PackageInfoItem';
import { getFormattedDuration } from '../../../../../utils/dateUtils';
import type { IPackageTransferInfo } from '../types';

const StyledWrapper = styled.div`
  padding-top: 3px;
`;

const transferStyles = css`
  display: flex;
  align-items: center;
  column-gap: 5px;
`;

const Transfer = styled.li<{ isMobile: boolean }>`
  justify-content: ${({ isMobile }) =>
    isMobile ? 'space-between' : 'flex-start'};
  ${transferStyles}
`;

const TransferTime = styled.div`
  flex-shrink: 0;
  ${transferStyles}
`;

const StyledClock = styled(Clock)`
  stroke: #4d4d4d;
  width: 16px;
  height: 16px;
`;

const StyledBus = styled(Bus)`
  width: 23px;
  color: #4d4d4d;
`;

const TRANSPORT_ICON = (
  <StyledWrapper>
    <StyledBus />
  </StyledWrapper>
);

const PackageTransferInfo: FC<IPackageTransferInfo> = ({
  transfer = false,
  airports = null,
  isPrivate = false,
  isMobile = false,
  isFetching = false,
}) => {
  const { t } = useTranslation();

  const text = transfer ? (
    <>
      <StyledTransfer>
        {t('checkout.packageInfo.transfer.title', {
          context: isPrivate ? 'private' : 'group',
        })}
      </StyledTransfer>
      {t('checkout.packageInfo.transfer.airport')} &mdash;{' '}
      {t('filters.distance.hotel')} &mdash;{' '}
      {t('checkout.packageInfo.transfer.airport')}
      <ul>
        {airports &&
          airports.map((airport) => (
            <Transfer isMobile={isMobile} key={airport.id}>
              {`${t('checkout.packageInfo.transfer.airportDistance')} ${
                airport.name
              }`}
              <TransferTime>
                <StyledClock />
                {`${t(
                  'checkout.packageInfo.transfer.time',
                )} ${getFormattedDuration(airport.transferTime)}`}
              </TransferTime>
            </Transfer>
          ))}
      </ul>
    </>
  ) : (
    <span className="text">{t('checkout.packageInfo.transfer.text')}</span>
  );
  return (
    <PackageInfoItem
      hasError={transfer}
      icon={TRANSPORT_ICON}
      text={isFetching ? t('checkout.packageInfo.transfer.fetching') : text}
      isMobile={isMobile}
    />
  );
};

const StyledTransfer = styled.span`
  display: flex;
  align-items: center;

  > i {
    margin: 2px 3px 0;
  }
`;

export default PackageTransferInfo;
